module.exports = __webpack_public_path__ + "img/034-alarm.bcd2f6d7.png";